module.exports = __webpack_public_path__ + "img/s1bg_m.48a7a34d.png";